import React, { ReactNode } from "react";
import { cn } from "@/lib/utils";
import PageLayout from "./PageLayout";

interface DetailPageLayoutProps {
  children: ReactNode;
  className?: string;
}

/**
 * DetailPageLayout - Standard wrapper for all entity detail pages
 * 
 * Provides:
 * - Consistent max-width and responsive padding via PageLayout
 * - Standardized spacing for detail page content
 * - Mobile-first responsive behavior
 * 
 * Use in combination with DetailPageHeader for complete detail page structure:
 * 
 * @example
 * <DetailPageLayout>
 *   <DetailPageHeader
 *     title="Project Name"
 *     backLink={{ label: "Back to Projects", href: "/projects" }}
 *     primaryAction={{ label: "Edit", onClick: handleEdit }}
 *   />
 *   <div className="grid gap-6 lg:grid-cols-3">
 *     <Card>...</Card>
 *     <Card className="lg:col-span-2">...</Card>
 *   </div>
 * </DetailPageLayout>
 */
const DetailPageLayout: React.FC<DetailPageLayoutProps> = ({
  children,
  className,
}) => {
  return (
    <PageLayout maxWidth="xl" padding="md">
      <div className={cn("space-y-6", className)}>
        {children}
      </div>
    </PageLayout>
  );
};

export default DetailPageLayout;
